<template>
  <section class="rounded-lg border border-slate-200 bg-slate-50 p-3">
    <div class="mb-2 flex items-center justify-between gap-3">
      <div>
        <div class="form-label">企业标签</div>
        <p class="mt-0.5 text-xs text-slate-500">用于下游标签偏好的软匹配。</p>
      </div>
      <span v-if="loading" class="text-xs text-slate-400">加载中...</span>
    </div>

    <el-select
      :model-value="modelValue"
      multiple
      filterable
      clearable
      collapse-tags
      collapse-tags-tooltip
      :max-collapse-tags="3"
      class="w-full bg-white"
      placeholder="选择企业标签"
      :disabled="disabled || loading"
      @update:model-value="emit('update:modelValue', normalizeTagIds($event))"
    >
      <el-option
        v-for="tag in enabledTags"
        :key="tag.id"
        :label="tag.tagName"
        :value="tag.id"
      >
        <div class="flex items-center justify-between gap-2">
          <span>{{ tag.tagName }}</span>
          <span v-if="modelValue.includes(tag.id)" class="text-xs font-medium text-primary-600">已选</span>
        </div>
      </el-option>
    </el-select>

    <div v-if="selectedTags.length > 0" class="mt-2 flex flex-wrap gap-1.5">
      <span
        v-for="tag in selectedTags"
        :key="tag.id"
        class="data-table-inline-tag"
      >
        {{ tag.tagName }}
      </span>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  tags: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false }
})

const emit = defineEmits(['update:modelValue'])

const enabledTags = computed(() =>
  [...(props.tags || [])]
    .filter(tag => tag?.enabled !== false)
    .sort((left, right) => {
      const leftOrder = Number(left?.displayOrder || 0)
      const rightOrder = Number(right?.displayOrder || 0)
      if (leftOrder !== rightOrder) return leftOrder - rightOrder
      return String(left?.tagName || '').localeCompare(String(right?.tagName || ''), 'zh-CN')
    })
)

const selectedTags = computed(() => {
  const selected = new Set(props.modelValue.map(value => String(value)))
  return enabledTags.value.filter(tag => selected.has(String(tag.id)))
})

function normalizeTagIds(value) {
  return Array.isArray(value)
    ? value.filter(item => item !== null && item !== undefined && item !== '')
    : []
}
</script>
